import script from "./PaymentList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentList.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentList.vue?vue&type=style&index=0&id=3f99b6bb&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f99b6bb"]])

export default __exports__